import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';
import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { GameCenterComponentGridAreas } from '../../styles';

export const LineScoreContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.lineScore};

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const LineScoreHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}
`;

export const FinalContainer = styled.div`
    display: flex;
    ${BaseStyle.Mixins.gaps.extraSmall}

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        ${BaseStyle.Mixins.gaps.medium}
    }
`;

export const TeamLogo = styled(TeamDisplay)`
    flex: initial;

    img {
        height: 32px;
        width: 48px;

        ${BaseStyle.Mixins.screenSizes.large} {
            height: 24px;
            width: 32px;
        }

        ${BaseStyle.Mixins.screenSizes.extraLarge} {
            height: 32px;
            width: 48px;
        }
    }
`;

export const TeamInfoContainer = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
`;

export const TeamAbbrev = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        ${BaseStyle.Mixins.fontStyles.ui['16b']}
    }
`;

export const Record = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
`;

export const ShootoutColumn = styled.span`
    color: ${({ theme }) => theme.Text.secondary};
`;
